<template>
  <div class="polish">
    <div class="switch-lang">
      <span
        v-for="item in switchList"
	        :key="item.value"
	        class="item"
	        :class="[item.value === currentLang.value ? 'active' : '']"
	        :data-track-text="`选择润色语言${item.name}`"
	        :aria-label="`选择润色语言${item.name}`"
	        @click="selectLang(item)"
      >
        {{ item.name }}
      </span>
    </div>
    <div class="polish-container">
      <div class="origin-text" :class="[isShowExplain ? 'show-explain' : '']">
        <div class="option">
          <div
            class="option-item"
	            :class="[currentAssistant.id === item.id ? 'active' : '']"
	            v-for="item in assistantList"
	            :key="item.id"
	            :data-track-text="`选择润色助手${item.title}`"
	            :aria-label="`选择润色助手${item.title}`"
	            @click="selectAssistant(item)"
          >
            {{ item.title }}
          </div>
        </div>
        <el-input
          rows="16"
          resize="none"
          class="textarea"
          type="textarea"
          placeholder="请输入要润色的文字……"
          v-model="originText"
          maxlength="3000"
          show-word-limit
          @focus="requestAuthentication"
        >
        </el-input>
        <div
	          class="polish-btn"
	          :class="[!isTalking && originText ? 'active' : '']"
	          data-track-text="提交润色"
	          aria-label="提交润色"
	          @click="polish"
        >
          润 色
        </div>
      </div>
      <div
        class="translate-container"
        :class="[isShowExplain ? 'show-explain' : '']"
      >
        <div class="title">
          <span class="el-icon-daimashengcheng" style="font-size: 18px"></span>
          润色-{{ this.currentAssistant.title }}
          <button v-if="reasoningContent && !isShowExplain" type="button" @click="showExplain">查看改写说明</button>
        </div>
	        <div class="translate-text" title="点击复制" data-track-text="复制润色结果" aria-label="复制润色结果" @click="copyTranslate">
          <!-- <el-scrollbar class="translate-scrollbar"> -->
          {{ translateText }}
          <!-- </el-scrollbar> -->
        </div>
      </div>
      <div class="explain" v-if="isShowExplain">
        <div class="title">
          <span class="icon"> </span>
          改写说明
        </div>
        <span class="close" data-track-text="关闭改写说明" aria-label="关闭改写说明" @click="closeExplain">
          <i class="el-icon-close"></i>
        </span>
        <div class="content">{{ reasoningContent }}</div>
      </div>
    </div>
    <PackagePop ref="packagePop" />
  </div>
</template>
<script>
import PackagePop from "./PackagePop";
import { readChatStream, splitPolishResult, selectChatModel } from "../../utils/chatStream";
export default {
  // 组件名称
  name: "Polish",
  components: {
    PackagePop,
  },
  props: {
    userInfo: {
      type: String,
      default: "",
    },
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
    aiModelList: {
      type: Array,
      default: () => [],
    },
  },
  // 变量声明
  data() {
    return {
      switchList: [
        {
          name: "中文",
          value: "zh",
        },
        {
          name: "英文",
          value: "en",
        },
      ],
      currentLang: {
        name: "英文",
        value: "en",
      },
      aiMode: {
        model: "QIANWEN",
        name: "千问大模型",
      },
      assistantList: [],
      currentAssistant: {},
      originText: "",
      translateText: "",
      isTalking: false,
      chatNumber: "",
      conversationId: "",
      activeRequest: null,
      explanationClosed: false,
      isShowExplain: false,
      reasoningContent: "",
    };
  },
  watch: {
    aiModelList: {
      immediate: true,
      handler() {
        if (!this.isTalking) this.getCurrentModel();
      },
    },
  },
  // 实例初始化之后,进行数据侦听和事件/侦听器的配置之前同步调用
  beforeCreate() {},
  // 实例创建，挂载阶段未开始，可进行数据初始化
  created() {},
  mounted() {
    this.getAssistantType();
    this.getAssistant();
  },
  beforeDestroy() {
    this.cancelGeneration();
  },
  // 方法
  methods: {
    requestAuthentication() {
      if (this.isAuthenticated) {
        return true;
      }
      this.$emit("getUserStatus");
      return false;
    },
    cancelGeneration() {
      if (this.activeRequest) this.activeRequest.controller.abort();
      this.activeRequest = null;
      this.isTalking = false;
    },
    async polish() {
      if (!this.requestAuthentication() || this.isTalking || !this.originText.trim()) return;
      if (!this.currentAssistant.id || !this.currentAssistant.tag || !this.aiMode.model) {
        this.$message.error("助手或模型尚未加载，请稍后重试");
        return;
      }
      const request = { controller: new AbortController() };
      this.activeRequest = request;
      this.isTalking = true;
      this.clearTranslateText();
      const model = this.aiMode.model;
      const prompt = this.originText;
      const assistant = { ...this.currentAssistant };
      const to = this.currentLang.value;
      try {
        const created = (await this.$http.post("/chatApi/v1/chat/createChat", {
          model, assistantId: assistant.id, prompt,
        })).data;
        if (this.activeRequest !== request) return;
        if (created.code !== 200 || !created.data || !created.data.chatNumber) {
          throw new Error(created.msg || "创建会话失败，请重试");
        }
        this.chatNumber = created.data.chatNumber;
        const message = (await this.$http.post("/chatApi/v1/chat/message", {
          model, prompt, chatNumber: this.chatNumber, to,
          assistantTag: assistant.tag, assistantTypeTag: "text_polish",
        })).data;
        if (this.activeRequest !== request) return;
        if (message.code !== 200 || !message.data) {
          if (message.code === 600) this.$refs.packagePop.open();
          throw new Error(message.msg || "发送失败，请重试");
        }
        this.conversationId = message.data;
        const response = await fetch(
          `/chatApi/v1/chat/completions?conversationId=${encodeURIComponent(message.data)}`,
          { method: "get", signal: request.controller.signal,
            headers: { authorization: localStorage.getItem("token") } }
        );
        if (this.activeRequest !== request) return;
        await readChatStream(response, (data) => {
          if (this.activeRequest !== request) return;
          const result = splitPolishResult(data.content);
          this.translateText = result.text;
          this.reasoningContent = result.notes;
          this.isShowExplain = !!result.notes && !this.explanationClosed;
        });
      } catch (error) {
        if (this.activeRequest === request && error.name !== "AbortError") {
          const message = error.message || "润色失败，请重试";
          if (this.translateText) this.translateText += `\n\n[生成未完成：${message}]`;
          this.$message.error(message);
        }
      } finally {
        if (this.activeRequest === request) {
          this.activeRequest = null;
          this.isTalking = false;
        }
      }
    },
    copyTranslate() {
      if (this.translateText.length) {
        this.$copyText(this.translateText);
        this.$message.success("复制成功");
      }
    },
    showExplain() {
      this.explanationClosed = false;
      this.isShowExplain = true;
    },
    closeExplain() {
      this.explanationClosed = true;
      this.isShowExplain = false;
    },
    clearTranslateText() {
      this.translateText = "";
      this.reasoningContent = "";
      this.isShowExplain = false;
      this.explanationClosed = false;
    },
    selectLang(item) {
      this.cancelGeneration();
      this.currentLang = item;
      this.clearTranslateText();
    },
    selectAssistant(item) {
      this.cancelGeneration();
      this.currentAssistant = item;
      this.clearTranslateText();
    },
    getCurrentModel() {
      this.aiMode = { ...selectChatModel(this.aiModelList, this.aiMode, "polish_default") };
    },
    getAssistantType() {
      this.$http.get("/chatApi/app/api/assistant/type").then((res) => {});
    },
    getAssistant() {
      this.$http
        .get("/chatApi/app/api/assistant", {
          params: {
            typeId: 12,
          },
        })
        .then((res) => {
          this.assistantList = res.data.data || [];
          this.currentAssistant = this.assistantList[0] || {};
        });
    },
  },
};
</script>
<style lang="less" scoped>
.polish {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .switch-lang {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    margin-bottom: 16px;
    .item {
      padding: 8px 32px;
      cursor: pointer;
      font-weight: 500;
      font-size: 15px;
      color: var(--muted-foreground);
      background: var(--bg-card);
      border: 1px solid var(--border);
      position: relative;
      transition: background-color .15s, color .15s, border-color .15s;
      &.active {
        background: var(--primary);
        color: #ffffff;
        border-color: var(--primary);
        z-index: 9;
      }
      &:first-child {
        border-radius: var(--radius-xl) 0 0 var(--radius-xl);
        border-right: none;
      }
      &:last-child {
        border-radius: 0 var(--radius-xl) var(--radius-xl) 0;
      }
    }
  }
  .polish-container {
    display: flex;
    flex: 1;
    min-height: 0;
    width: 100%;
    .origin-text,
    .translate-container {
      position: relative;
      flex: 0 0 50%;
      box-sizing: border-box;
      &.show-explain {
        flex: 0 0 calc(50% - 120px);
      }
    }
    .origin-text {
      padding: 16px 20px 60px 20px;
      background: var(--bg-card);
      border-radius: var(--radius-xl) 0 0 var(--radius-xl);
      border: 1px solid var(--border);
      .option {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 12px;
        .option-item {
          font-size: 13px;
          padding: 6px 16px;
          color: var(--muted-foreground);
          background: var(--bg-subtle);
          border: 1px solid var(--border);
          border-radius: var(--radius-lg);
          cursor: pointer;
          transition: background-color .15s, color .15s, border-color .15s;
          &:hover {
            border-color: var(--primary);
            color: var(--primary);
          }
          &.active {
            background: var(--primary);
            color: #ffffff;
            border-color: var(--primary);
          }
        }
      }
      /deep/.el-input__count {
        right: 120px;
        bottom: 46px;
      }
      .polish-btn {
        position: absolute;
        bottom: 16px;
        right: 20px;
        padding: 0 28px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        background: var(--muted-fg-light);
        border-radius: var(--radius-lg);
        cursor: pointer;
        font-size: 15px;
        font-weight: 500;
        color: #ffffff;
        transition: background-color .15s, box-shadow .15s;
        &.active {
          background: var(--primary);
          box-shadow: var(--shadow-primary);
          &:hover {
            background: var(--primary-dark);
          }
        }
      }
      .textarea {
        height: 100%;
        /deep/textarea {
          border: none;
          height: calc(100% - 60px);
          font-size: 15px;
          line-height: 1.7;
          color: var(--foreground);
          background: transparent;
        }
      }
    }
    .translate-container {
      background: var(--bg-subtle);
      border-radius: 0 var(--radius-xl) var(--radius-xl) 0;
      border: 1px solid var(--border);
      border-left: none;
      padding: 16px 20px;
      .title {
        font-size: 14px;
        font-weight: 500;
        color: var(--muted-foreground);
        line-height: 28px;
        display: flex;
        align-items: center;
        gap: 6px;
      }
      .translate-text {
        color: var(--foreground);
        font-size: 15px;
        line-height: 1.7;
        margin-top: 12px;
        height: calc(100% - 40px);
        overflow: auto;
        cursor: pointer;
        white-space: pre-wrap;
        word-break: break-word;
      }
    }
    .explain {
      width: 240px;
      background: var(--bg-card);
      border: 1px solid var(--border);
      border-left: none;
      border-radius: 0 var(--radius-xl) var(--radius-xl) 0;
      padding: 16px 20px;
      box-sizing: border-box;
      .title {
        color: var(--foreground-secondary);
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        display: flex;
        align-items: center;
        gap: 6px;
        .icon {
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url(../../assets/chat/menu/polish.png) center no-repeat;
          background-size: contain;
          vertical-align: bottom;
        }
      }
      .close {
        position: absolute;
        top: 12px;
        right: 14px;
        cursor: pointer;
        color: var(--muted-fg-light);
        font-size: 16px;
        &:hover {
          color: var(--foreground);
        }
      }
      .content {
        font-size: 13px;
        color: var(--muted-foreground);
        line-height: 1.7;
        margin-top: 14px;
        white-space: pre-wrap;
        word-break: break-word;
      }
    }
  }
}

/* 润色改写移动端：上下分区布局 */
@media (max-width: 768px) {
  .polish {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    overflow: hidden;

    .switch-lang {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0;
      width: 100%;
      margin: 0 0 10px;
      padding: 0;

      .item {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 86px;
        height: 32px;
        padding: 0 20px;
        border-radius: var(--radius-lg);
        box-sizing: border-box;
        font-size: 14px;
        line-height: 32px;

        &.active,
        &:first-child.active,
        &:last-child.active {
          margin: 0;
        }
        &:first-child {
          border-right: 1px solid var(--border);
          border-radius: var(--radius-lg);
        }
        &:last-child {
          border-radius: var(--radius-lg);
        }
      }
    }

    .polish-container {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      width: 100%;
      height: auto;
      min-width: 0;
      min-height: 0;
      margin-top: 0;
      overflow-x: hidden;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;

      .origin-text,
      .translate-container {
        width: 100%;
        min-width: 0;
        box-sizing: border-box;

        &.show-explain {
          flex-basis: auto;
        }
      }

      .origin-text {
        display: flex;
        flex: 1 0 300px;
        flex-direction: column;
        min-height: 300px;
        padding: 12px 12px 52px;
        border-radius: var(--radius-xl) var(--radius-xl) 0 0;
        border-bottom: none;

        .option {
          display: flex;
          flex-wrap: wrap;
          flex: 0 0 auto;
          gap: 8px;
          width: 100%;
          min-width: 0;
          margin-bottom: 8px;

          .option-item {
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 0;
            height: 32px;
            padding: 0 12px;
            overflow: hidden;
            box-sizing: border-box;
            text-align: center;
            text-overflow: ellipsis;
            font-size: 13px;
            line-height: 32px;
            white-space: nowrap;
          }
        }

        .textarea {
          flex: 1 1 auto;
          width: 100%;
          height: auto;
          min-width: 0;
          min-height: 0;

          /deep/ textarea {
            width: 100%;
            height: 100%;
            min-height: 120px;
            padding: 8px;
            box-sizing: border-box;
            font-size: 15px;
            line-height: 1.6;
          }
        }

        /deep/ .el-input__count {
          right: 100px;
          bottom: 12px;
        }

        .polish-btn {
          right: 12px;
          bottom: 12px;
          padding: 0 24px;
          height: 36px;
          border-radius: var(--radius-md);
          font-size: 14px;
          line-height: 36px;
        }
      }

      .translate-container {
        flex: 1 0 220px;
        min-height: 220px;
        padding: 12px 14px;
        border-radius: 0 0 var(--radius-xl) var(--radius-xl);
        border: 1px solid var(--border);
        border-top: none;

        .title {
          font-size: 13px;
          line-height: 24px;
        }

        .translate-text {
          height: calc(100% - 36px);
          margin-top: 8px;
          overflow-y: auto;
          font-size: 15px;
          line-height: 1.6;
          overflow-wrap: anywhere;
          word-break: break-word;
        }
      }

      .explain {
        flex: 0 0 auto;
        width: 100%;
        height: auto;
        min-height: 200px;
        padding: 14px 16px;
        box-sizing: border-box;
        border-radius: var(--radius-xl);
        border: 1px solid var(--border);

        .close {
          top: 14px;
          right: 14px;
        }

        .content {
          margin-top: 10px;
          overflow-wrap: anywhere;
          word-break: break-word;
        }
      }
    }
  }
}
</style>
